import { getNoise } from "@/utils/noise";
import Image from "next/image";
import classNames from "classnames";
import { SocialProofAvatars } from "./SocialProofAvatars";
import { formatAmount } from "@/utils";
import { MIN_SOCIAL_PROOF, MAX_SOCIAL_PROOF } from "@/constants/noise";

export const SocialProof = ({
	position = "top",
	text = "",
	variant = "light",
	showNoise = true,
	textVariant = "normal",
	count = 0,
}) => {
	const noise = getNoise("glutenfreeq", {
		min: MIN_SOCIAL_PROOF,
		max: MAX_SOCIAL_PROOF,
		range: MAX_SOCIAL_PROOF - MIN_SOCIAL_PROOF,
	});

	return (
		<div className="flex items-center gap-2">
			<div
				style={{ width: count > 0 && `${(count - 1) * 12 + 20}px` }}
				className={classNames({
					"w-11 h-5": variant === "landing-page",
					"w-[68px] h-5": variant !== "landing-page",
					"w-auto flex justify-center items-center relative": count > 0,
				})}>
				{count > 0 ? (
					<SocialProofAvatars
						count={count}
						avatarsBorderColor={variant === "white"
							? "white"
							: variant === "light" ? "#212b37" : "black"}
					/>
				) : (
					<Image
						alt="Gluten Free Users"
						style={{ objectFit: "contain" }}
						width={variant === "landing-page" ? 100 : 68}
						height={variant === "landing-page" ? 100 : 68}
						src={
							variant === "landing-page"
								? "/assets/avatars/avatars-c.png"
								: variant === "light"
									? "/assets/avatars/avatars.png"
									: "/assets/avatars/avatars-b.png"
						}
					/>
				)}
			</div>
			<label
				className={classNames({
					"md:text-lg": position !== "none",
					"font-semibold": textVariant === "bold",
					"text-[13px]  font-medium font-inter": true,
					"text-white": variant === "light" || variant === "dark-porange" || variant === "white",
					"text-blue-900": variant === "dark" || variant === "landing-page",
				})}>
				{showNoise ? `${noise.value} ` : ""}
				{count ? `${formatAmount(count)} ` : ""}
				{text || "joined today"} {position === "top" ? "👇" : ""}
				{position === "bottom" ? "👆" : ""}
				{position === "left" ? "👉" : ""}
				{position === "right" ? "👈" : ""}
			</label>
		</div>
	);
};
